<template>
  <div class="collapse_item__wrappers mb-2">
    <div class="collapse_item__header mb-1">
      <div class="collapse_item__header_text">
        <slot name="title">
          <span>{{ title }}</span>
        </slot>
      </div>
      <div class="collapse_item__header_icon">
        <div v-if="!disabled" class="d-flex">
          <div
            class="icon_class mr-1"
            @click="$emit('command', buttonInfo)"
            v-for="(buttonInfo, index) in buttonList"
            :key="index"
          >
            <i :class="buttonInfo.icon" />
          </div>
        </div>
      </div>
    </div>
    <div class="collapse_item__body">
      <el-collapse-transition>
        <slot />
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    buttonList: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss" scoped>
.collapse_item__wrappers {
  .collapse_item__header {
    display: flex;
    align-items: center;
    .collapse_item__header_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      margin-right: 6px;
      .icon_class {
        background-color: rgba(9, 30, 66, 0.08);
        height: 17px;
        width: 17px;
        line-height: 17px;
        border-radius: 5px;
        text-align: center;
        color: #344563;
      }
    }
    // .tool-btn {
    //   background-color: #f8f8f8;
    //   border-radius: 5px;
    // }
    // .tool-btn:hover {
    //   background-color: #d7d7d7 !important;
    // }
    .collapse_item__header_text {
      flex: 1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.icon_class:hover {
  background-color: rgba(9, 30, 66, 0.13) !important;
}
</style>
